import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { styleHighlight } from './olStyles.js';
import { parseHtmlString, parseHtmlStringForIDWMgroup } from './htmlbuilder.js';

import { getUrlForInfoFromImageOrTile } from './maptoolkit.js';

export function setMapEvents(map, parentContainer) {
  highlightLayerFeature(map);
  setEventGetLayersInfo(map, parentContainer);
}

function highlightLayerFeature(map) {
  const highlightLayer = new VectorLayer({
    source: new VectorSource(),
    style: styleHighlight,
    name: 'highlightCtry',
    zIndex: 9997,
    visible: true,
  });

  map.addLayer(highlightLayer);

  map.on('singleclick', function (event) {
    highlightLayer.getSource().clear();

    const clickedFeature = map.forEachFeatureAtPixel(event.pixel, function (feature, layer) {
      if (layer instanceof VectorLayer) {
        const layerName = layer.get('name')?.toLowerCase();
        if (layerName && layerName.includes('idwm')) {
          const info = getCountry(feature);
          if (info) {
            return feature;
          }
        }
      }
    });

    if (clickedFeature) {
      const featureToHighlight = clickedFeature.clone();
      let src = highlightLayer.getSource();
      src.addFeature(featureToHighlight);
    }
  });
}

export function getCountry(feature) {
    let c1 = feature.get('ctry');
    let c2 = feature.get('CTRY');
    let c = c1 ? c1 : c2;
    return c;
  }

function setEventGetLayersInfo(map, parentContainer) {
  const mapInfosContainer = document.getElementById('oim-map-infos-container-' + parentContainer.id);
  //const mapInfosContainer = document.querySelector('.oim-map-infos-container');
  let classpadding = 'oim-map-infos-container-padding';
  map.on('singleclick', async function (evt) {
    var pixel = map.getEventPixel(evt.originalEvent);
    let infos = [];
    let idwmInfo = getIdwmInfoFromJSON(map, pixel);
    if (idwmInfo) {
      infos.push(idwmInfo);
    }

    let idwmInfo2 = await getIdwmInfoFromImageOrTile(map, evt);
    if (idwmInfo2) {
      infos.push(idwmInfo2);
    }

    let UNInfo = await getUNInfoFromImageOrTile(map, evt);
    if (UNInfo) {
      infos.push(UNInfo);
    }
    if (infos.length > 0) {
      if (!mapInfosContainer.classList.contains(classpadding)) {
        mapInfosContainer.classList.add(classpadding);
      }
    } else {
      mapInfosContainer.classList.remove(classpadding);
    }
    mapInfosContainer.innerText = infos.join(', ');
  });
}

async function getIdwmInfoFromImageOrTile(map, evt) {
  let url = getUrlForInfoFromImageOrTile(map, evt, true);

  if (url) {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      let infos = '';
      const data = await response.text();
      if (data) {
        infos = formatIDWMInfo(data);
      }
      return infos;
    } catch (error) {
      console.error('There was a problem with the query operation:', error);
      throw error;
    }
  } else {
    return '';
  }
}

function getIdwmInfoFromJSON(map, pixel) {
  let info = '';
  map.forEachFeatureAtPixel(pixel, (feature, layer) => {
    if (layer && layer instanceof VectorLayer && feature) {
      let layerName = layer.get('name')?.toLowerCase();
      // if (layerName && layerName.includes('idwm')) {
      //   info = '';
      //   info += feature.get('CTRY');
      //   return info;

      //}
      
if (layerName?.includes('idwm')) {
    return getCountry(feature);   //it does not display it on the map
  }

  // IMPORTANT: non-idwm layers
  return '';

    }
  });
  return info;
}

async function getUNInfoFromImageOrTile(map, evt) {
  let url = getUrlForInfoFromImageOrTile(map, evt, false);
  if (url) {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      let infos = '';
      const data = await response.text();
      if (data) {
        infos = formatUNInfo(data);
      }
      return infos;
    } catch (error) {
      console.error('There was a problem with the query operation:', error);
      throw error;
    }
  } else {
    return '';
  }
}

function formatIDWMInfo(data) {
  let result = {
    fid: {
      index: null,
      value: null,
    },
    ctry: {
      index: null,
      value: null,
    },
    id: {
      index: null,
      value: null,
    },
  };
  let hasInfo = true;
  let info;
  let { ths, tds } = parseHtmlStringForIDWMgroup(data);
  if (ths.length > 0 && tds.length > 0) {
    Object.keys(result).forEach((key) => {
      let index = ths.indexOf(key);
      if (index == -1) {
        hasInfo = false;
      }
      result[key].index = index;
      result[key].value = tds[index];
    });
  } else {
    hasInfo = false;
  }
  if (hasInfo) {
    info = `IDWM: [${getCountry()}]`;
  }
  return info;

  function getValue(key) {
    return `${result[key].value}`;
  }

    function getCountry() {
    let c1 = `${result['ctry'].value}`;
    let c2 = `${result['CTRY'].value}`;
    let c = c1 ? c1 : c2;
    return c;
  }

}

function formatUNInfo(data) {
  let result = {
    ISO3CD: {
      index: null,
      value: null,
    },
    ISOADM: {
      index: null,
      value: null,
    },
    ROMNAM: {
      index: null,
      value: null,
    },
    STSCOD: {
      index: null,
      value: null,
    },
  };
  let hasInfo = true;
  let info;
  let { ths, tds } = parseHtmlString(data);
  if (ths.length > 0 && tds.length > 0) {
    Object.keys(result).forEach((key) => {
      let index = ths.indexOf(key);
      if (index == -1) {
        hasInfo = false;
      }
      result[key].index = index;
      result[key].value = tds[index];
    });
  } else {
    hasInfo = false;
  }
  if (hasInfo) {
    // info = `UNmaps: [${getValue('ROMNAM')}, ${getValue('ISO3CD')}, ${getValue('ISOADM')}, ${getValue('STSCOD')}]`;
    info = `UNmaps: [${getValue('ROMNAM')}, ${getValue('ISO3CD')}, ${getValue('ISOADM')}, ${getValue('STSCOD')}]`;
  }
  return info;

  function getValue(key) {
    return `${result[key].value}`;
  }
}
